import React, { useContext, useEffect, useRef, useState } from 'react'
import { AuthContext } from '../../context/AuthContext'
import { useHttp } from '../../hooks/http.hook'
import { observer } from 'mobx-react'
import Modal from '../Modal'
import ModalForm from './ModalForm/ModalForm'
import LiveSearchInput from '../Inputs/LiveSearchInput/LiveSearchInput'
import { daDataRequest } from '../../api.external/daDataRequest'
import FormInput from '../Inputs/FormInput/FormInput'
import RadioCheckInput from '../Inputs/RadioCheckbox/RadioCheckInput'
import PropTypes from 'prop-types'
import AttentionGenerator from '../Form/AttentionGenerator'

const DaDataModal = observer((props) => {
  const { request } = useHttp()
  const baseURl = process.env.REACT_APP_BASE_URL
  const { token } = useContext(AuthContext)
  const [status, setStatus] = useState()
  const [daData, setDaData] = useState()
  const [formData, setFormData] = useState({
    role: '',
    name: '',
    inn: '',
    kpp: '',
    payed: '',
    address: ''
  })

  const nameRef = useRef()
  const innRef = useRef()
  const kppRef = useRef()
  const addressRef = useRef()


  const addOrg = async (e) => {
    e.preventDefault()
    const url = `${baseURl}${props.url}`
    const { data, status } = await request(url, 'POST', formData, { Authorization: `Bearer ${token.token}` })
    setStatus(status)
  }

  const daDataInputHandler = (e) => {
    daDataRequest(e.target.value, setDaData)
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const inputHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  function optionClickHandler(kpp, inn) {
    daData.forEach(item => {
      if (item.data?.kpp === kpp && inn === item.data?.inn) {
        innRef.current.value = item.data.inn
        nameRef.current.value = item.data.name?.short || item.data.name?.full 
        kppRef.current.value = item.data.kpp  || ""
        addressRef.current.value = item.data.address.value

        setFormData({
          ...formData,
          name: nameRef.current.value,
          inn: innRef.current.value,
          kpp: kppRef.current.value,
          address: addressRef.current.value
        })

      }
    })
  }
  useEffect(() => {
    if (props.role) {
      setFormData({ ...formData, role: props.role })
    }

  }, [props.data])

  return (
    <Modal styles={{ left: '90px', zIndex: '101' }}>
      <ModalForm closeHandler={props.closeHandler} onSubmit={addOrg}
                 readyText={'Контрагент добавлен!'}
                 readyBtnText={'Продолжить'}
                 ready={status === 201 || status === 200}
                 submitDisabled={!(
                   formData.payed &&
                   formData.role && formData.name && formData.inn)}
                 onSubmitTitle={'Сохранить'}
                 title={'Карта контрагента организации (1)'}>


        <LiveSearchInput optionClickHandler={optionClickHandler}
                         reff={nameRef}
                         name={'inn'}
                         storage={daData}
                         onChange={daDataInputHandler}
                         id={'inn'}
                         title={<>Название <span style={{ color: 'red' }}>*</span></>} />

        <LiveSearchInput optionClickHandler={optionClickHandler}
                         name={'inn'}
                         reff={innRef}
                         storage={daData}
                         onChange={daDataInputHandler}
                         id={'inn'}
                         title={<>ИНН <span style={{ color: 'red' }}>*</span></>} />

        <FormInput onChange={inputHandler} reff={kppRef} name={'kpp'} hideIcon title={'КПП'} />
        <FormInput onChange={inputHandler} reff={addressRef} name={'address'} hideIcon title={'Адрес'} />
        <FormInput onChange={inputHandler} name={'email'} hideIcon type={'email'} title={'E-Mail'} />

        <div style={{ width: '100%', marginTop: '20px' }}>
          <div style={{ marginBottom: '20px' }}>Вид организации <span style={{ color: 'red' }}>*</span></div>
          {formData.role == 5
            ? <RadioCheckInput checked={formData.role === 5} name={'role'} onChange={_ => {}}
                               value={5} id={'def2'} title={'Удостоверяющий центр'} />
            : ''}
          {formData.role == 4
            ? <RadioCheckInput checked={formData.role === 4} name={'role'} onChange={_ => {}} value={4}
                               id={'def2'}
                               title={'Мед. центр'} />
            : ''}
          {formData.role == 3
            ? <RadioCheckInput checked={formData.role === 3} name={'role'} onChange={_ => {}} value={3}
                               id={'def2'}
                               title={'Организация'} />
            : ''}

          <div style={{ marginBottom: '20px', marginTop: '20px' }}>
            Дебиторская задолженность <span
            style={{ color: 'red' }}>*</span></div>
          <RadioCheckInput name={'payed'} onChange={inputHandler} value={true} id={'def3'} title={'Да'} />
          <RadioCheckInput name={'payed'} onChange={inputHandler} value={false} id={'def3'} title={'Нет'} />
        </div>

      </ModalForm>
    </Modal>
  )
})

DaDataModal.propTypes = {
  url: PropTypes.string,
  closeHandler: PropTypes.func,
  data: PropTypes.shape({
    name: PropTypes.string
  })
}

export default DaDataModal
